import { render, staticRenderFns } from "./I2FormInput.vue?vue&type=template&id=da0eaa5e&scoped=true&"
import script from "./I2FormInput.vue?vue&type=script&lang=js&"
export * from "./I2FormInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0eaa5e",
  null
  
)

export default component.exports